var _path, _path2, _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKmf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#5196ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2754_2901",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2754_2901)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.5V17.25H23V11.5H0Z",
    fill: "#AF0100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.75V11.5H23V5.75H0Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V5.75H23V0H0Z",
    fill: "#FBCD17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0L11.5 11.5L0 23V0Z",
    fill: "#5EAA22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53142 16.7284C4.53142 16.7284 1.95588 15.4496 2.04697 11.4468C2.13807 7.44397 4.76056 6.65962 4.76056 6.65962C3.84213 5.69489 0.555759 6.8254 0.450587 11.4468C0.345414 16.0682 3.55212 17.0949 4.53142 16.7284ZM4.66801 9.85675L4.76483 9.10406L4.35468 8.57101L4.92149 8.46119L5.17497 7.77638L5.42845 8.46119L5.99526 8.57101L5.58511 9.10406L5.68194 9.85675L5.17497 9.50138L4.66801 9.85675ZM4.76483 11.0207L4.66801 11.7734L5.17497 11.418L5.68194 11.7734L5.58511 11.0207L5.99526 10.4877L5.42845 10.3779L5.17497 9.69304L4.92149 10.3779L4.35468 10.4877L4.76483 11.0207ZM4.66801 13.6901L4.76483 12.9374L4.35468 12.4043L4.92149 12.2945L5.17497 11.6097L5.42845 12.2945L5.99526 12.4043L5.58511 12.9374L5.68194 13.6901L5.17497 13.3347L4.66801 13.6901ZM4.66801 15.6067L4.76483 14.8541L4.35468 14.321L4.92149 14.2112L5.17497 13.5264L5.42845 14.2112L5.99526 14.321L5.58511 14.8541L5.68194 15.6067L5.17497 15.2514L4.66801 15.6067Z",
    fill: "#F7FCFF"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2754_2901)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2754_2901",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmf);
export default __webpack_public_path__ + "static/media/KMF.b71a661ef5d7e52e8026676c422bd0b7.svg";
export { ForwardRef as ReactComponent };